import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

export function useGetBmProUtmLinks({
  source,
  campaign,
  content,
  medium,
}: {
  source?: string
  campaign?: string
  content?: string
  medium?: string
}): string {
  const { market } = useMarketplace()
  const campaignDefault = `LIF_B2B_ALL_${market.countryCode}_INAP_BM4BConvergenceRedirection`

  const UTM_SOURCE = source || 'bm_b2c_header'
  const UTM_MEDIUM = medium || 'website'
  const UTM_CAMPAIGN = !campaign ? campaignDefault : campaign
  const UTM_CONTENT = content || 'header'

  return `https://pro${market.domain}/?utm_source=${UTM_SOURCE}&utm_medium=${UTM_MEDIUM}&utm_campaign=${UTM_CAMPAIGN}&utm_content=${UTM_CONTENT}`
}
